import React from 'react';
import {
	FlashbarProps,
} from '@amzn/awsui-components-console';

import GenericWizard from 'src/components/commonComponents/GenericWizard/GenericWizard';
import { generateReviewSectionsFromSteps } from 'src/components/commonComponents/GenericWizard/utils/wizardUtils';

import {
	ApplicationProfileFormMetadata,
	getApplicationWizardSteps,
} from '../AddApplication/ApplicationFormGenerationUtils';

interface EditApplicationPageProps {
	onCancel: () => void;
	onSubmit: (data: ApplicationProfileFormMetadata) => void;
	isLoading: boolean;
	flashBarItems?: FlashbarProps.MessageDefinition[];
	error?: string | null;
	applicationName: string | null;
}

const EditApplicationForm: React.FC<EditApplicationPageProps> = ({
	onCancel,
	onSubmit,
	flashBarItems,
	error,
	isLoading,
	applicationName,
}) => {
	return (
		<GenericWizard<ApplicationProfileFormMetadata>
			title="Edit Application"
			description={`Update details for ${applicationName || 'this application'}`}
			steps={getApplicationWizardSteps()}
			onCancel={onCancel}
			onSubmit={onSubmit}
			isLoading={isLoading}
			errorMessage={error}
			flashBarItems={flashBarItems}
			reviewTitle="Review Application Changes"
			submitButtonText="Update Application"
			generateReviewSections={generateReviewSectionsFromSteps}
		/>
	);
};

export default EditApplicationForm;